import React from 'react';
import { ICompany } from '../../../customTypings/company/Company';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { FormField, FormSubmitButton, FormAlert } from '../../forms';
import { companyValidationSchema } from '../../../utils';
import { useFormSubmit } from '../../../hooks';
import { companyService } from '../../../services';

interface CompanyInfoFormProps {
  company?: ICompany;
  onSuccess?: () => void;
}

export const CompanyInfoForm: React.FC<CompanyInfoFormProps> = ({
  company,
  onSuccess,
}) => {
  const { isSubmitting, error, submitForm } = useFormSubmit({
    onSubmit: async (values: ICompany) => {
      const serviceMethod = company?.id ? companyService.update : companyService.create;
      return await serviceMethod(values);
    },
    onSuccess: () => {
      onSuccess?.();
    },
    successMessage: company?.id 
      ? 'Company information updated successfully'
      : 'Company information created successfully',
  });

  const initialValues: ICompany = company || {
    id: '',
    phone: '',
    contactEmail: '',
    line1: '',
    line2: '',
    line3: '',
    town: '',
    country: '',
    postcode: '',
    website: '',
    invitationEmail: '',
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={companyValidationSchema}
      onSubmit={submitForm}
      enableReinitialize
    >
      <Form>
        <FormAlert message={error || undefined} variant="danger" />
        
        <Row>
          <Col md={6}>
            <FormField
              name="phone"
              label="Phone"
              type="tel"
              required
              placeholder="Enter phone number"
            />
          </Col>
          <Col md={6}>
            <FormField
              name="contactEmail"
              label="Contact Email"
              type="email"
              required
              placeholder="Enter contact email"
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormField
              name="line1"
              label="Address Line 1"
              required
              placeholder="Enter address line 1"
            />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormField
              name="line2"
              label="Address Line 2"
              placeholder="Enter address line 2 (optional)"
            />
          </Col>
          <Col md={6}>
            <FormField
              name="line3"
              label="Address Line 3"
              placeholder="Enter address line 3 (optional)"
            />
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <FormField
              name="town"
              label="Town/City"
              required
              placeholder="Enter town or city"
            />
          </Col>
          <Col md={4}>
            <FormField
              name="country"
              label="Country"
              required
              placeholder="Enter country"
            />
          </Col>
          <Col md={4}>
            <FormField
              name="postcode"
              label="Postcode"
              required
              placeholder="Enter postcode"
            />
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormField
              name="website"
              label="Website"
              type="url"
              placeholder="Enter website URL (optional)"
            />
          </Col>
          <Col md={6}>
            <FormField
              name="invitationEmail"
              label="Invitation Email"
              type="email"
              required
              placeholder="Enter invitation email"
            />
          </Col>
        </Row>

        <div className="d-flex justify-content-end">
          <FormSubmitButton>
            {company?.id ? 'Update Company' : 'Create Company'}
          </FormSubmitButton>
        </div>
      </Form>
    </Formik>
  );
}; 
